// extracted by mini-css-extract-plugin
module.exports = {"root":"LenderTable_root__2-KJw","title":"LenderTable_title__16Zmj","tableContainer":"LenderTable_tableContainer__2l9xU","tableHeaderCell":"LenderTable_tableHeaderCell__35M-z"};